import BlokWrap from "@/components/bloks/BlokWrap";
import { NavigationMenuLink } from "@/components/ui/NavigationMenu";
import type { BlokRouter } from "@/data/routes/bloks.route";
import type { BlokCategorySection } from "@/storyblok";
import type { BlokProps } from "@frend-digital/storyblok";
import styles from "./CategorySection.module.css";

export const CategorySectionBlok = ({
	blok,
	data,
}: BlokProps<BlokCategorySection, BlokRouter["categorySection"]>) => {
	if (!data) return null;
	return (
		<BlokWrap editable={blok} as="div" className={styles.root}>
			<p className={styles.title}>{blok.title}</p>
			<menu className={styles.links}>
				{data.subCategories.map((category) => {
					return (
						<li key={category.category}>
							<NavigationMenuLink href={`/${category.uri}`}>
								{category.name?.at(-1)}
							</NavigationMenuLink>
						</li>
					);
				})}
			</menu>
		</BlokWrap>
	);
};
